// @ts-nocheck
import React, { useEffect, useRef, useCallback } from "react"
import { style } from "./pixiBoardStyle"

import { boardContainer } from "./container/Container"

import { createPixiApp } from "./helpers/createPixiApp"
import { resizeHelper } from "./helpers/resizeHelper"
import { addChildren } from "./helpers/addChildren"

import { Paralax } from "./background/paralax"
import { randomWhiteComet } from "./background/whiteComets/comets"

// import rocket from "./rocket/Rocket"
import { jump } from "./astronaut/jump"
import { raise } from "./rocket/fire/raiseAndSlow"
import { VerticalMoving } from "./rocket/verticalMoving/verticalMoving"
import { Moving } from "./rocket/moving"

import { Lose } from "./rocket/lose"

import { CreateRocket } from "./rocket/CreateRocket"

import { AsteroidMovement } from "./asteroid/asteroidMovement"

let app: any = null

const { rocket, rocketBackToStartingPosition } = new CreateRocket(
  boardContainer,
)

const { addParalax, paralaxUpdater, setSpeed, sizeUpdater } = new Paralax()
const { verticalMovingUpdater, resetVerticalElapse, vertical } =
  new VerticalMoving(rocket)

const {
  setTickerMoving,
  moveToAsteroidNow,
  getIsMovingDirectionRight,
  moveNow,
  resetRocketMovingVariables,
} = new Moving(rocket)

const { removeDebrisAndBoom, handleLose, setTickerForLose } = new Lose(
  rocket,
  boardContainer,
  setSpeed,
  getIsMovingDirectionRight,
)

const {
  clearAsteroidInterval,
  setWasThereBoom,
  setTickerAsteroidMovement,
  goAsteroids,
  goRealAsteroid,
  clearAsteroids,
  setGameAbortHandler,
} = new AsteroidMovement(
  rocket,
  boardContainer,
  handleLose,
  verticalMovingUpdater,
  moveToAsteroidNow,
  getIsMovingDirectionRight,
  moveNow,
)

export function PixiBoard({ round, cashoutedUser, handleAbortGame }: any) {
  const ref = useRef<any>(null)

  useEffect(() => {
    app = createPixiApp(ref, app)
    setTickerAsteroidMovement(app.ticker)
    setTickerMoving(app.ticker)
    setTickerForLose(app.ticker)
    addParalax(app.stage)
    addChildren(app, boardContainer, rocket)
    randomWhiteComet(app.stage, app.ticker)
  }, [])

  useEffect(() => {
    setGameAbortHandler(handleAbortGame)
  }, [handleAbortGame])

  const resizeHandler = () => resizeHelper(sizeUpdater, boardContainer, app)
  useEffect(() => {
    window.addEventListener("resize", resizeHandler)
    return () => window.removeEventListener("resize", resizeHandler)
  }, [])

  useEffect(() => {
    if (round.state === 1 && round.starttimer === 4) {
      app.ticker.remove(verticalMovingUpdater)
      rocketBackToStartingPosition()
      resetRocketMovingVariables()
      resetVerticalElapse()
      setWasThereBoom()
    }
    if (round.state === 2) {
      removeDebrisAndBoom()
      app?.ticker.remove(paralaxUpdater)
      app?.ticker.add(paralaxUpdater)
      raise(app.ticker)
      vertical(app.ticker)
      setSpeed(20)
      goAsteroids()
      resetVerticalElapse()
      resetRocketMovingVariables()
      setWasThereBoom()
    }
    if (round.state === 3) {
      goRealAsteroid()
    }
  }, [round.state, round.starttimer])

  useEffect(() => {
    jump(app.ticker, rocket)
  }, [cashoutedUser])

  const changingVisibility = useCallback(() => {
    if (document.visibilityState === "visible") {
      app.ticker.start()
      clearAsteroidInterval()
      clearAsteroids()
      const astsInContainer = boardContainer.children.filter(
        item => item.name === "ast",
      )
      astsInContainer.map(ast => boardContainer.removeChild(ast))
      removeDebrisAndBoom()

      if (round.state === 1 && round.starttimer < 4) {
        clearAsteroidInterval()
        boardContainer.removeChild(rocket)
      }

      if (round.state === 1 && round.starttimer >= 4) {
        app.ticker.remove(verticalMovingUpdater)
        rocketBackToStartingPosition()
        resetRocketMovingVariables()
        resetVerticalElapse()
        setWasThereBoom()
      }

      if (round.state === 2) {
        rocketBackToStartingPosition()
        resetRocketMovingVariables()
        setSpeed(20)
        raise(app.ticker)
        vertical(app.ticker)
        setWasThereBoom()
        resetVerticalElapse()
        // app?.ticker.remove(paralaxUpdater, "backg")
        // app?.ticker.add(paralaxUpdater, "backg")
        setTimeout(() => {
          goAsteroids()
        }, 400)
      }

      if (round.state === 3) {
        boardContainer.removeChild(rocket)
        const astsInContainer = boardContainer.children.filter(
          item => item.name === "ast",
        )
        astsInContainer.map(ast => boardContainer.remove(ast))
      }
    }
    if (document.visibilityState === "hidden") {
      app.ticker.stop()
    }
  }, [round.state, round.starttimer])

  useEffect(() => {
    window.addEventListener("visibilitychange", changingVisibility)
    return () =>
      window.removeEventListener("visibilitychange", changingVisibility)
  }, [changingVisibility])

  return <div style={style} ref={ref}></div>
}

export default React.memo(PixiBoard)
